import {fetcher} from 'src/global/fetcher';
import {ModulesListType} from "./types";

export const ModulesService = {
    getUserModules: () => fetcher.get<{modules: ModulesListType}>('user/modules'),
};
